<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED">For Valisa, Eunice, Steve, and Buck—The members of my first EVENT … I miss them beyond measure.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2a4d1a33